const authApi = require('../api/auth');
const api = require('../api');
const { fetchComicsIfNeeded } = require('./ComicActions');
const { fetchUser } = require('./UserActions');
const {
  FETCH_USER_SUCCESSFUL,
  SET_EMAIL_AFTER_REGISTER,
} = require('../reducers/auth');
const { fetchCountryIfNeeded } = require('./CountryActions');

function loginSuccessful(token) {
  return (dispatch) => {
    dispatch({
      type: 'LOGIN_SUCCESSFUL',
      token,
      timestamp: Date.now(),
    });
    return dispatch(fetchUser());
  };
}

function logoutSuccesful() {
  return {
    type: 'LOGOUT_SUCCESSFUL',
    timestamp: Date.now(),
  };
}

function logout() {
  return (dispatch) => {
    dispatch(logoutSuccesful());
  };
}

function setApiUrl(apiUrl) {
  return (dispatch, getState) => {
    if (getState().auth.apiUrl !== apiUrl) {
      dispatch({
        type: 'SET_API_URL',
        apiUrl,
        timestamp: Date.now(),
      });

      dispatch(fetchCountryIfNeeded());
      dispatch(fetchComicsIfNeeded());
    }
  };
}

function setRedirectPath(redirectPath) {
  return {
    type: 'SET_REDIRECT_PATH',
    redirectPath,
  };
}

function register(email, password, captchaResponse = '') {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .register(apiUrl, email, password, {
        'g-recaptcha-response': captchaResponse,
      })
      .then((responseJson) => {
        dispatch({ type: SET_EMAIL_AFTER_REGISTER, email });
        return dispatch(loginSuccessful(responseJson.token));
      });
  };
}

function googleLogin(code) {
  const client = {
    type: 'lootboy-lib',
    userAgent: navigator.userAgent,
  };

  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .googleLogin(
        apiUrl,
        {
          serverAuthCode: code,
        },
        client,
      )
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function googleLoginApp(accessToken) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .googleLoginApp(apiUrl, {
        accessToken,
      })
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function facebookLogin(code) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .facebookLogin(apiUrl, {
        code,
      })
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function facebookLoginApp(accessToken) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .facebookLoginApp(apiUrl, {
        accessToken,
      })
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function appleLogin(code) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .appleLogin(apiUrl, {
        code,
      })
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function twitterLogin(jwtToken) {
  return (dispatch) => Promise.resolve(dispatch(loginSuccessful(jwtToken)));
}

function twitterLoginApp(userId, authTokenSecret, accessToken) {
  const client = {
    type: 'lootboy-lib',
    userAgent: navigator.userAgent,
  };

  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .twitterLoginApp(
        apiUrl,
        {
          user_id: userId,
          oauth_token_secret: authTokenSecret,
          oauth_token: accessToken,
        },
        client,
      )
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function steamLogin(jwtToken) {
  return (dispatch) => Promise.resolve(dispatch(loginSuccessful(jwtToken)));
}

function twitchLogin(jwtToken) {
  return (dispatch) => Promise.resolve(dispatch(loginSuccessful(jwtToken)));
}

function instagramLogin(jwtToken) {
  return (dispatch) => Promise.resolve(dispatch(loginSuccessful(jwtToken)));
}

function passwordLogin(username, password, captchaResponse = '') {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .passwordLogin(
        apiUrl,
        {
          username,
          password,
        },
        {
          'g-recaptcha-response': captchaResponse,
        },
      )
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function resetPassword(token, newPassword) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;

    return authApi
      .resetPassword(apiUrl, token, newPassword)
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function requestPasswordResetToken(email, code) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;

    return authApi.requestPasswordResetToken(apiUrl, email, code);
  };
}

function requestPasswordReset(user, captchaResponse = '') {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;

    return authApi.requestPasswordReset(apiUrl, user, {
      'g-recaptcha-response': captchaResponse,
    });
  };
}

function connectWithDiscord(code) {
  return (dispatch, getState) => {
    const state = getState();

    const { apiUrl, token } = state.auth;

    if (!apiUrl || !token) {
      return Promise.resolve();
    }

    return authApi.connectWithDiscord(apiUrl, token, code).then((user) => {
      dispatch({
        type: FETCH_USER_SUCCESSFUL,
        user,
      });
      return user;
    });
  };
}

function huaweiLogin(code) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;
    return authApi
      .huaweiLogin(apiUrl, { code })
      .then((responseJson) => dispatch(loginSuccessful(responseJson.token)));
  };
}

function captchaVerificationSuccessful({ token, signature }) {
  return {
    type: 'CAPTCHA_SOLVED',
    signature,
    legitimateToken: token,
  };
}

function verifyCaptcha(captchaResponse) {
  return (dispatch, getState) => {
    const { apiUrl } = getState().auth;

    return authApi
      .verifyCaptcha(apiUrl, captchaResponse)
      .then(({ token, signature }) => {
        api.setLegitimateToken(token);
        api.setSignature(signature);
        dispatch(captchaVerificationSuccessful({ token, signature }));
      });
  };
}

module.exports = {
  register,
  googleLogin,
  googleLoginApp,
  facebookLogin,
  facebookLoginApp,
  twitterLogin,
  twitterLoginApp,
  steamLogin,
  twitchLogin,
  instagramLogin,
  huaweiLogin,
  loginSuccessful,
  passwordLogin,
  logout,
  setApiUrl,
  setRedirectPath,
  resetPassword,
  requestPasswordResetToken,
  requestPasswordReset,
  connectWithDiscord,
  verifyCaptcha,
  appleLogin,
};
